import { Link } from 'react-router-dom';
import CardState from '../../profile/ui/CardState';

const KIND_LABEL = { access: 'Tool access', proposal: 'New tool proposal', app: 'App you’re building' };

export default function MyRequestsCard({ requests }) {
  return (
    <section className="home-card" aria-labelledby="home-req-h">
      <div className="home-card__head">
        <h2 id="home-req-h" className="home-card__title">My requests</h2>
        <Link className="home-link" to="/requests#sub=mine">All requests</Link>
      </div>
      {requests.status === 'loading' && <CardState kind="loading" label="Loading your requests" lines={3} />}
      {requests.status === 'error' && (
        <>
          <p className="home-muted">Couldn’t load your requests.</p>
          <button type="button" className="home-link-btn" onClick={requests.retry}>Try again</button>
        </>
      )}
      {requests.status === 'ready' && !requests.partial && requests.rows.length === 0 && (
        <p className="home-muted">
          No open requests. <Link className="home-link" to="/requests#sub=access">Request a tool</Link>
        </p>
      )}
      {requests.status === 'ready' && requests.rows.length > 0 && (
        <ul className="home-list">
          {requests.rows.map((r) => (
            <li key={r.key}>
              <Link className="home-row" to={r.href}>
                <span className="home-row__text">
                  <span className="home-row__title" title={r.title}>{r.title}</span>
                  <span className="home-row__detail">{KIND_LABEL[r.kind]}</span>
                </span>
                <span className="home-pill home-pill--status">{r.statusLabel}</span>
              </Link>
            </li>
          ))}
        </ul>
      )}
      {requests.status === 'ready' && requests.partial && (
        <p className="home-muted">
          Couldn’t load some of your requests.{' '}
          <button type="button" className="home-link-btn" onClick={requests.retry}>Try again</button>
        </p>
      )}
    </section>
  );
}
